// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"f9393d19","455":"1b991356","633":"03061bf2"}[chunkId] + ".chunk.js";
};